import { isCortexAllowedFileExtension, User } from "common";

export const enableAiInsight = (
  reportExtension: string,
  reportFileSize: number,
  user?: User
) => {
  // Check feature flag first
  if (!user?.featureFlags?.FF_AI_REPORT_INTERPRET) {
    return false;
  }

  const MAXIMUM_FILE_SIZE = 1024 * 1024 * 15; // 15MB
  if (!isCortexAllowedFileExtension(reportExtension)) return false;
  return reportFileSize < MAXIMUM_FILE_SIZE;
};
